<template>
<el-form v-model="fromData" style="height: 100%;width: 100%">
  <!--      0-->
  <div style="height: 9%;width: 99%;margin: auto">
    <el-row class="row1">
      <el-col :span="8">
        CW制造部
      </el-col>
      <el-col :span="8">
        切断加工科生产看板
      </el-col>
      <el-col :span="8">
        {{ currentTime }}
      </el-col>
    </el-row>
  </div>

  <!--      1-->
  <el-row style="height: 24%;text-align: center;margin-top: 1%;">
    <el-col :span="12">
      <el-row :gutter="40" style="height: 45%;align-items: center;margin: 0;">
        <el-col :span="6">
          <div class="style1" style="background-color: #04cc7c;">&nbsp;在岗工人&nbsp;</div>
          <div class="style2">{{ fromData.worker_num }}</div>
        </el-col>
        <el-col :span="6">
          <div class="style1" style="background-color: #206fd5">&nbsp;开工物件&nbsp;</div>
          <div class="style2">{{ fromData.wujian_num }}</div>
        </el-col>
        <el-col :span="6">
          <div class="style1" style="background-color: #e4973d;">&nbsp;切断日产量&nbsp;</div>
          <div class="style2">{{ fromData.cut_daily_num +'KG'}}</div>
        </el-col>
        <el-col :span="6">
          <div class="style1" style="background-color: #e4653d;">&nbsp;加工日产量&nbsp;</div>
          <div class="style2">{{ fromData.process_daily_num +'KG'}}</div>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="12">
      <el-row :gutter="40" style="height: 5%;width: 200px;margin-left: 20px;text-align: left">
        <el-col style="border-left: 3px solid steelblue;" :span="24" >
          日不良重量
        </el-col>
      </el-row>
      <el-row :gutter="60" style="height: 95%;align-items: center;margin: 0">
        <el-col :span="24" v-loading="dayBadLoading" element-loading-text="数据加载中" style="height: 130%"
                id="processDayBad"/>
      </el-row>
    </el-col>
  </el-row>

  <!--      2-->
  <el-row style="height: 30%;">
    <el-col :span="12" style="margin-top: -6%">
      <el-row :gutter="40" style="height: 10%;align-items: center;width: 200px;margin-left: 20px;">
        <el-col style="border-left: 3px solid steelblue;" :span="24" >
          物件生产进度概况
        </el-col>
      </el-row>
      <el-row :gutter="40" style="height: 86%;align-items: center;margin: 0">
        <el-col :span="24" style="margin-top: -18%">
          <el-table :data="wujianList" border stripe style="padding: 0;height: 200px"
                    :header-cell-style="{textAlign: 'center',backgroundColor: '#0a84ff', color: '#ffffff',fontSize: '16px'}"
                    :cell-style="{ textAlign: 'center', color: '#0a84ff',fontSize: '16px',borderBottom: '0.5px #0a84ff solid', borderRight: '0.5px #0a84ff solid'}">
            <el-table-column prop="wujian_id" label="物件" min-width="200" fixed/>
            <el-table-column prop="floor" label="楼层" min-width="60" fixed/>
            <el-table-column prop="process_weight" label="加工重量(KG)" min-width="90" fixed/>
            <el-table-column prop="total_weight" label="总重量(KG)" min-width="90" fixed/>
            <el-table-column prop="completion_progress" label="生产进度" min-width="70"/>
          </el-table>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="12" style="margin-top: 1%">
      <!--  生产实绩-->
      <el-row :gutter="40" style="height: 5%;text-align:left;width: 200px;margin-left: 20px;">
        <el-col style="border-left: 3px solid steelblue;" :span="24" >
          加工生产实绩
        </el-col>
      </el-row>
      <el-row :gutter="60" style="height: 105%;align-items: center;margin: 0">
        <el-col :span="24" class="divSize" v-loading="produceActualOutputLoading" element-loading-text="数据加载中" style="height: 110%;"
                id="produceActualOutput"/>
      </el-row>
    </el-col>
  </el-row>
  <!--      3-->
  <el-row style="height: 42%;margin-top: -5%">
    <el-col :span="12" >
      <el-row :gutter="40" style="height: 10%;align-items: center;width: 200px;margin-left: 20px;">
        <el-col style="border-left: 3px solid steelblue;" :span="24" >
          技能等级看板
        </el-col>
      </el-row>

      <el-row style="height: 90%;margin: 0 20px;" :span="24">
      <div v-loading="userLoading" style="width: 100%; height: 100%; border-width: 1px 0 1px 0; border: whitesmoke solid">
        <div style="height: 24%; display: flex;">
          <div class="level1" style="background-color: #206fd5;">
            <span>{{"高级"}}</span>
          </div>
          <div class="level1-right">
          <div v-for="item in gGrade" :key="item.id" class="level2" :style="'height:' + 100/gGrade.length + '%'">
            <span class="grade">{{item.grade}}</span>
            <div class="scroll-container">
            <div class="scroll-content">
            <div v-for="user in item.gradeUsers" :key="user.id" class="userCard">
              <div style="width: 33%;height: 100%" class="border-right">
                <el-image style="width: 100%; height: 100%" :src="user?.headUrl" fit="fill">
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
              </div>
              <div style="width: 66%;height: 100%">
                <div class="sizeUser align-center border-bottom border-right">{{user.user_name}}</div>
                <div class="sizeUser align-center border-top border-bottom border-right">{{user.full_name}}</div>
                <div class="sizeUser align-center border-right">{{user.post}}</div>
              </div>
            </div>
            </div>
            </div>

          </div>
          </div>
        </div>
        <div style="height: 35%; display: flex">
          <div class="level1" style="background-color: #e4973d;">
            <span>{{"中级"}}</span>
          </div>
          <div class="level1-right">
            <div v-for="item in zGrade" :key="item.id" class="level2" :style="'height:' + 100/zGrade.length + '%'">
              <span class="grade">{{item.grade}}</span>
              <div class="scroll-container">
                <div class="scroll-content">
              <div v-for="user in item.gradeUsers" :key="user.id" class="userCard">
                <div style="width: 33%;height: 100%" class="border-right">
                  <el-image style="width: 100%; height: 100%" :src="user?.headUrl" fit="fill">
                    <template #error>
                      <div class="image-slot">
                        <el-icon><icon-picture /></el-icon>
                      </div>
                    </template>
                  </el-image>
                </div>
                <div style="width: 66%;height: 100%">
                  <div class="sizeUser align-center border-bottom border-right">{{user.user_name}}</div>
                  <div class="sizeUser align-center border-top border-bottom border-right">{{user.full_name}}</div>
                  <div class="sizeUser align-center border-right">{{user.post}}</div>
                </div>
              </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 35%; display: flex">
          <div class="level1" style="background-color: #04cc7c;">
            <span>{{"初级"}}</span>
          </div>
          <div class="level1-right">
            <div v-for="item in cGrade" :key="item.id" class="level2" :style="'height:' + 100/cGrade.length + '%'">
              <span class="grade">{{item.grade}}</span>
              <div class="scroll-container">
                <div class="scroll-content">
              <div v-for="user in item.gradeUsers" :key="user.id" class="userCard">
                <div style="width: 33%;height: 100%" class="border-right">
                  <el-image style="width: 100%; height: 100%" :src="user?.headUrl" fit="fill">
                    <template #error>
                      <div class="image-slot">
                        <el-icon><icon-picture /></el-icon>
                      </div>
                    </template>
                  </el-image>
                </div>
                <div style="width: 66%;height: 100%">
                  <div class="sizeUser align-center border-bottom border-right">{{user.user_name}}</div>
                  <div class="sizeUser align-center border-top border-bottom border-right">{{user.full_name}}</div>
                  <div class="sizeUser align-center border-right">{{user.post}}</div>
                </div>
              </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </el-row>

    </el-col>
    <el-col :span="12" style="margin-top: 5%">
      <el-row :gutter="40" style="height: 10%;align-items: center;width: 200px;margin-left: 20px;">
        <el-col style="border-left: 3px solid steelblue;" :span="24" >
          切断加工生产性
        </el-col>
      </el-row>
      <el-row :gutter="60" style="height: 100%;align-items: center;margin-top: -3%">
        <el-col :span="24" v-loading="jiaGongProductiveOutputLoading" element-loading-text="数据加载中" style="height: 90%;" id="jiaGongProductiveOutput"/>
      </el-row>
    </el-col>
  </el-row>
</el-form>
</template>

<script>
import {useDateFormat} from "@vueuse/core";
import * as echarts from "echarts";

export default {
  name: "CutOffProcessProductionKanBan",
  components: {},
  data() {
    return {
      currentTime: '',
      ///
      fromData: {
        dateDay: this.getDateFormat(),
      },
      processDayBad: {
        title: [
          {
            text: '',
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良重量(kg)',
            min:0,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(2)
              }
            }
          },
          {
            type: 'value',
            name: '累计不良率(%)',
            min:0,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(2) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '不良重量',
            type: 'bar',
            yAxisIndex:0,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '累计不良率',
            type: 'line',
            yAxisIndex: 1,
            // label: {
            //   show: true,
            //   position: 'top',
            //   formatter: (params) => params.value > 0 ? params.value : '',
            //   fontSize:'10'
            // },
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %';
              }
            },
            data: []
          },
          {
            name: '目标不良率',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %';
              }
            },
            data: []
          },
        ]
      },
      dayBadLoading: false,
      wujianData: [],
      wujianList: [],
      currentIndex: 0, // 当前显示的数据在allData中的起始索引
      intervalId: null, // 存储定时器的ID
      ///
      produceActualOutputLoading: false,
      produceActualOutput: {
        title: [
          {
            text: '',
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '加工实绩(kg)',
            interval:20,
            axisLabel: {
              formatter: function (value){
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: '累计实绩(kg)',
            interval:20,
            axisLabel: {
              formatter: function (value){
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          },
        ],
        series: [
          {
            name: '计划',
            type: 'bar',
            // yAxisIndex:0,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '实绩',
            type: 'bar',
            yAxisIndex:0,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '累计计划',
            type: 'line',
            color:'#fac858',
            yAxisIndex:1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '累计实绩',
            type: 'line',
            color:'#ee6666',
            yAxisIndex:1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      countDays:[],
      countDayList: [],
      month: this.getDateFormat(),
      ///
      jiaGongProductiveOutputLoading: false,
      jiaGongProductiveOutput: {
        title: [
          {
            text: '',
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '0' ,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '重量(kg)',
            min:0,
            axisLabel: {
              formatter: function (value){
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: '直接生产性',
            min:0,
            axisLabel: {
              formatter: function (value){
                return parseInt(value.toFixed(0)).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: '生产重量',
            type: 'bar',
            yAxisIndex: 0,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '直接人工',
            stack: '人工',
            type: 'bar',
            yAxisIndex: 1,
            color:'#6cb5f9',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '间接人工',
            stack: '人工',
            type: 'bar',
            color:'#fa9504',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '直接生产性',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '目标生产性',
            color:'#fac858',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '总生产性',
            type: 'line',
            color:'#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      productiveMonth : this.getDateFormat(),
      productiveYear:this.$common.getCurrentYearByMonth().toString(),
      gGrade:[],
      zGrade:[],
      cGrade:[],
      scrollId: null, // 滚动定时器的ID
      ///
      scrollDirection: ['right','right','right','right','right','right','right','right'],
      isScroll: ['right','right','right','right','right','right','right','right'],
      userLoading:false
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.startAutoScroll(); // 组件挂载后开始自动滚动
    })
  },

  unmounted() {
    this.stopAutoScroll()
  },
  methods: {
    /*判断字符串数组里的每一项是否相同*/
    isAllSame(arr) {
      if (arr.length === 0) {
        return true;
      }
      const firstItem = arr[0];
      return arr.every(item => item === firstItem);
    },

    startAutoScroll() {
      if (this.scrollId) {
        // 如果已经在滚动，则不再执行
        return;
      }
      this.scrollId = setInterval(() => {
        const containers = this.$el.querySelectorAll('.scroll-container');
        if (containers) {
          containers.forEach((container, index) => {
            if (this.scrollDirection[index] === 'right') {
              container.scrollLeft += 1;
              if (Math.ceil(container.scrollLeft) >= container.scrollWidth - container.clientWidth) {
                this.isScroll[index] = 'left'
                if (this.isAllSame(this.isScroll)) {
                  setTimeout(() => {
                    this.scrollDirection[index] = 'left';
                  }, 3000)
                }
              }
            } else {
              container.scrollLeft -= 1;
              if (container.scrollLeft === 0) {
                this.isScroll[index] = 'right'
                if (this.isAllSame(this.isScroll)) {
                  setTimeout(() => {
                    this.scrollDirection[index] = 'right';
                  }, 3000)
                }
              }
            }
          })
        }
      }, 50); // 每0.01秒滚动一次
    },
    stopAutoScroll() {
      if (this.scrollId) {
        clearInterval(this.scrollId);
        this.scrollId = null;
      }
    },
    dateFormat() {
      this.currentTime = useDateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss dddd')
    },
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    getProcessFromData() {
      this.$axios.post('mfg/processCalendar/getProcessFromData').then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("获取数据失败" + res.message);
        }
        this.fromData = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    renderEcharts(id,option) {
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
      }
    },
    //日不良
    async getProcessDayBad() {
      if (!this.fromData.dateDay){
        this.fromData.dateDay = this.getDateFormat()
      }
      this.fromData.countDayList = this.countDayList;
      this.dayBadLoading = true
      let {data: res} = await this.$axios.post('mfg/processProduce/getProcessDayBad',this.fromData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }

      this.processDayBad.xAxis[0].data = this.countDayList
      this.processDayBad.series[0].data = res.data.processDayBadWeightList
      this.processDayBad.series[1].data = res.data.processDayRateList
      this.processDayBad.series[2].data = res.data.productivityList

      let a = this.$common.getDivisor(Math.max(...res.data.processDayBadWeightList))
      this.processDayBad.yAxis[0].max = Math.ceil(Math.max(...res.data.processDayBadWeightList)/a)*a
      this.processDayBad.yAxis[0].interval = Math.round(this.processDayBad.yAxis[0].max/5*100)/100

      let b = 0
      for (let item of res.data.processDayRateList) {
        if (b < item) {
          b = item;
        }
      }

      if (Math.round(b) > 0) {
        b = Math.round(b)
      }

      if (b <= 0.1) {
        b = 0.1
      }

      if (b > 0.1 && b < 0.5) {
        b = b + 0.1
      }

      // this.processDayBad.yAxis[0].max = a
      // this.processDayBad.yAxis[0].interval = a / 5
      this.processDayBad.yAxis[1].max = b
      this.processDayBad.yAxis[1].interval = b / 5
      this.renderEcharts('processDayBad',this.processDayBad)
      this.dayBadLoading = false
    },
    //生产实绩
    getCountDays(month) {
      const d = new Date(month)
      const y = d.getFullYear()
      //获取本月的下一个月
      const m = d.getMonth() + 1
      // 下一个月的第0天就是这个月的天数
      this.countDays = new Date(y, m, 0).getDate();
      for (let i = 1; i <= this.countDays; i++) {
        //准备天数集合
        this.countDayList.push(i)
      }
    },
    async getProduceActual() {
      if (!this.month) {
        return this.$message.error('请先选择物件月份!')
      }
      let params = {countDayList: this.countDayList, thing:this.thing, month:this.month};
      this.produceActualOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/processProduce/getProduceActual', params);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.produceActualOutput.xAxis[0].data = res.data.xAxis
        this.produceActualOutput.series[0].data = res.data.planList
        this.produceActualOutput.series[1].data = res.data.actualList
        //this.produceActualOutput.series[2].data = res.data.differenceList
        this.produceActualOutput.series[2].data = res.data.accumulatePlanList
        this.produceActualOutput.series[3].data = res.data.accumulateActualList
        let maxA = this.$common.getMaxValue(res.data.planList,res.data.actualList)

        //let a = this.$common.getDivisor(Math.max(...res.data.actualList))
        this.produceActualOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.produceActualOutput.yAxis[0].interval = Math.round(this.produceActualOutput.yAxis[0].max / 5 * 100) / 100

        let maxB = this.$common.getMaxValue(res.data.accumulatePlanList,res.data.accumulateActualList)
        this.produceActualOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.produceActualOutput.yAxis[1].interval = Math.round(this.produceActualOutput.yAxis[1].max / 5 * 100) / 100
        // let b = this.$common.getDivisor(Math.max(...res.data.accumulateActualList))
        // this.produceActualOutput.yAxis[1].max = Math.ceil(Math.max(...res.data.accumulateActualList)/b)* (b + 5)
        // this.produceActualOutput.yAxis[1].interval = Math.round(this.produceActualOutput.yAxis[1].max/5*100)/100
      }
      this.renderEcharts('produceActualOutput', this.produceActualOutput)
      this.produceActualOutputLoading = false
    },
    async getDayProductiveOutput() {
      this.jiaGongProductiveOutputLoading = true
      if (!this.productiveYear) {
        return this.$message.error("年不能为空");
      }
      let params
      if (!this.productiveMonth) {
        params = {month:this.productiveMonth, year:this.productiveYear}
      } else {
        params = {countDayList: this.countDayList,month:this.productiveMonth, year:this.productiveYear};
      }
      let {data: res} = await this.$axios.post('mfg/processProduceAchievement/getJiaGongProductive',params);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.jiaGongProductiveOutput.xAxis[0].data = res.data.xAxis
        this.jiaGongProductiveOutput.series[0].data = res.data.weightList
        this.jiaGongProductiveOutput.series[1].data = res.data.zjTotalManHourList
        this.jiaGongProductiveOutput.series[2].data = res.data.jjTotalManHourList
        this.jiaGongProductiveOutput.series[3].data = res.data.directProductivityList
        this.jiaGongProductiveOutput.series[4].data = res.data.productivityList
        this.jiaGongProductiveOutput.series[5].data = res.data.totalProductiveList

        let a = this.$common.getDivisor(Math.max(...res.data.weightList))
        let b = this.$common.getDivisor(Math.max(...res.data.directProductivityList))
        this.jiaGongProductiveOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.weightList)/a)*(a + 3)
        this.jiaGongProductiveOutput.yAxis[0].interval = Math.round(this.jiaGongProductiveOutput.yAxis[0].max/5*100)/100
        this.jiaGongProductiveOutput.yAxis[1].max = Math.ceil(Math.max(...res.data.directProductivityList)/b)*b
        this.jiaGongProductiveOutput.yAxis[1].interval = Math.round(this.jiaGongProductiveOutput.yAxis[1].max/5*0.5)/0.5
      }
      this.renderEcharts('jiaGongProductiveOutput',this.jiaGongProductiveOutput)

      this.jiaGongProductiveOutputLoading = false
    },
    async getWujianProductionProgressData() {
      await this.$axios.get('mfg/processProduce/getWujianProductionProgressData').then(async response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("获取数据失败" + res.message);
        }
        this.wujianData = res.data;
        //初始4条
        this.wujianList = this.wujianData.slice(this.currentIndex, this.currentIndex + 4);
        this.currentIndex = 4;
        if (this.currentIndex > this.wujianList.length) {
          this.currentIndex = 0;
        }

      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //每过10秒切换4条
    startDataRefresh() {
      this.stopDataRefresh(); // 确保只有一个定时器运行
      this.intervalId = setInterval(() => {
        this.wujianList = this.wujianData.slice(this.currentIndex, this.currentIndex + 4);
        this.currentIndex += 4;
        if (this.currentIndex >= this.wujianData.length) {
          this.currentIndex = 0; // 循环到数据末尾时重置索引
        }
      }, 10000); // 每10秒更新一次
    },
    stopDataRefresh() {
      clearInterval(this.intervalId);
    },
    async getUserSkillGrade() {
      this.userLoading = true
      let {data:res} = await this.$axios.post('train/trainUser/getUserSkillGrade',"638864377dd623e881e6a4a2")
      this.grade = res.data
      res.data.forEach((item)=>{

        if (item.grade.includes("高")){
          this.gGrade.push(item)
        }
        if (item.grade.includes("中")){
          this.zGrade.push(item)
        }
        if (item.grade.includes("初")){
          this.cGrade.push(item)
        }
      })
      this.userLoading = false
    },
  },
  created() {
    this.timer1 = setInterval(() => {
      this.dateFormat();
    }, 1000)
    var currentDate = new Date();
    //currentDate.setDate(currentDate.getDate() - 1);
    this.getCountDays(currentDate);
    this.getProcessDayBad()
    this.getProduceActual()
    this.getDayProductiveOutput()
    this.getProcessFromData()
    this.getWujianProductionProgressData()
    this.startDataRefresh();
    this.timer2 = setInterval(() => {
      this.getProcessFromData()
      this.getProcessDayBad()
      this.getProduceActual()
      this.getDayProductiveOutput()
      this.getWujianProductionProgressData()
    }, 300000)
    this.getUserSkillGrade()
  },
  beforeUnmount() {
    this.stopDataRefresh();
  }
}
</script>

<style scoped>
.border {
  border:rgb(216, 220, 230) 1px solid;
}
.row1 {
  height: 100%;
  margin-top: 5px;
  text-align: center;
  align-items: center;
  font-size: 35px;
  background-color: #1b8dff;
  color: whitesmoke;
  border-radius: 12px;
  font-weight: bold
}

.style1 {
  color: whitesmoke;
  border-radius: 4px;
  font-size: 25px;
}

.style2 {
  font-weight: bold;
  font-size: 20px;
  margin-top: 10px;
}

.level1{
  width: 8%;
  height:100%;
  color: whitesmoke;
  display: flex;
  justify-content: center;
  align-items: center
}

.level2{
  border:solid whitesmoke;
  border-width: 2px 0 2px 0;
  width: 100%;
  display: flex;
  align-items: center;
}

.grade{
  width: 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 2px whitesmoke solid;
}

.level1-right{
  width: 90%;
  display: flex;
  flex-direction: column
}

.userCard{
  width: 120px;
  height: 100%;
  display: flex;
}

.sizeUser{
  font-size: 0.9vh;
  height: 33%;
}

.border-right{
  border-right: 2px whitesmoke solid;
}

.border-left{
  border-left: 1px whitesmoke solid;
}

.border-bottom{
  border-bottom: 1px whitesmoke solid;
}

.border-top{
  border-top: 1px whitesmoke solid;
}

.align-center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.scroll-container {
  width: 100%;
  height: 100%;
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none; /* Firefox */
}

.scroll-content {
  display: flex;
  /* 添加你需要的样式 */
  /*animation: scroll 15s linear infinite; !* 设置动画 *!*/
}

@keyframes scroll {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(0); }
}

</style>